"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sha256 = void 0;

var tslib_1 = require("tslib");

var constants_1 = require("./constants");

var RawSha256_1 = require("./RawSha256");

var util_utf8_browser_1 = require("@aws-sdk/util-utf8-browser");

var Sha256 =
/** @class */
function () {
  function Sha256(secret) {
    this.hash = new RawSha256_1.RawSha256();

    if (secret) {
      this.outer = new RawSha256_1.RawSha256();
      var inner = bufferFromSecret(secret);
      var outer = new Uint8Array(constants_1.BLOCK_SIZE);
      outer.set(inner);

      for (var i = 0; i < constants_1.BLOCK_SIZE; i++) {
        inner[i] ^= 0x36;
        outer[i] ^= 0x5c;
      }

      this.hash.update(inner);
      this.outer.update(outer); // overwrite the copied key in memory

      for (var i = 0; i < inner.byteLength; i++) {
        inner[i] = 0;
      }
    }
  }

  Sha256.prototype.update = function (toHash) {
    if (isEmptyData(toHash) || this.error) {
      return;
    }

    try {
      this.hash.update(convertToBuffer(toHash));
    } catch (e) {
      this.error = e;
    }
  };
  /* This synchronous method keeps compatibility
   * with the v2 aws-sdk.
   */


  Sha256.prototype.digestSync = function () {
    if (this.error) {
      throw this.error;
    }

    if (this.outer) {
      if (!this.outer.finished) {
        this.outer.update(this.hash.digest());
      }

      return this.outer.digest();
    }

    return this.hash.digest();
  };
  /* The underlying digest method here is synchronous.
   * To keep the same interface with the other hash functions
   * the default is to expose this as an async method.
   * However, it can sometimes be useful to have a sync method.
   */


  Sha256.prototype.digest = function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        return [2
        /*return*/
        , this.digestSync()];
      });
    });
  };

  return Sha256;
}();

exports.Sha256 = Sha256;

function bufferFromSecret(secret) {
  var input = convertToBuffer(secret);

  if (input.byteLength > constants_1.BLOCK_SIZE) {
    var bufferHash = new RawSha256_1.RawSha256();
    bufferHash.update(input);
    input = bufferHash.digest();
  }

  var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
  buffer.set(input);
  return buffer;
}

function isEmptyData(data) {
  if (typeof data === "string") {
    return data.length === 0;
  }

  return data.byteLength === 0;
}

function convertToBuffer(data) {
  if (typeof data === "string") {
    return util_utf8_browser_1.fromUtf8(data);
  }

  if (ArrayBuffer.isView(data)) {
    return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
  }

  return new Uint8Array(data);
}